import { ToastNotificationsWrapper } from '@tanium/react-toast-notifications-wrapper';
import { useAuthCallbacks } from '../../auth/useAuthCallbacks';
import { AuthProvider, AuthState } from '../../auth/Auth';
import { AuthenticatedArea } from '../AuthenticatedArea/AuthenticatedArea';
import { UnauthenticatedArea } from '../UnauthenticatedArea/UnauthenticatedArea';
import { FullPageSpinner } from '../FullPageSpinner';

interface Props {
  authProvider: AuthProvider;
}

export const AppContainer: React.VFC<Props> = ({ authProvider }) => {
  const auth = useAuthCallbacks(authProvider);
  const { authState } = auth;

  if (authState === AuthState.LOADING) {
    return <FullPageSpinner />;
  }

  return authState === AuthState.SIGNED_IN ? (
    <ToastNotificationsWrapper>
      <AuthenticatedArea auth={auth} />
    </ToastNotificationsWrapper>
  ) : (
    <UnauthenticatedArea auth={auth} />
  );
};
